import { useDebounceFn } from 'ahooks';
import { useTranslations } from 'next-intl';
import { LOGIN_ERROR_INTL_PREFIX } from '../constants';

interface ValidationCallbacks {
  onValidationChange: (isValid: boolean, errorMsg: string) => void;
}

export const useValidation = ({ onValidationChange }: ValidationCallbacks) => {
  const t = useTranslations();

  const { run: checkEmail } = useDebounceFn(
    (email: string) => {
      if (!email) {
        onValidationChange(false, '');
        return;
      }
      if (/^[\w.-]+@[\w-]+(\.[\w-]+)+$/.test(email)) {
        onValidationChange(true, '');
      } else {
        onValidationChange(false, t(`${LOGIN_ERROR_INTL_PREFIX}emailInvalid`));
      }
    },
    { wait: 500 },
  );

  const { run: checkPhone } = useDebounceFn(
    (phone: string) => {
      if (!phone) {
        onValidationChange(false, '');
        return;
      }
      if (/^1[3-9]\d{9}$/.test(phone)) {
        onValidationChange(true, '');
      } else {
        onValidationChange(false, t(`${LOGIN_ERROR_INTL_PREFIX}phoneInvalid`));
      }
    },
    { wait: 500 },
  );

  return {
    checkEmail,
    checkPhone,
  };
};
